import React from "react";
import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";
import { useTranslation } from "react-i18next";
import { TESTIMONIALS } from "../lib/constants";

export default function TestimonialsMarquee() {
  const { t } = useTranslation();
  return (
    <section
      data-testid="testimonials-marquee"
      className="relative border-y-2 border-brand-orange bg-brand-black py-10 text-white"
    >
      <div className="mx-auto mb-6 max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="flex flex-wrap items-end justify-between gap-2">
          <h2 className="font-display text-3xl uppercase tracking-tight sm:text-4xl">
            {t("testimonials.title")}
          </h2>
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
            <span className="flex">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star key={i} className="h-4 w-4 fill-brand-orange text-brand-orange" />
              ))}
            </span>
            135+ Google Reviews · 5.0
          </div>
        </div>
      </div>

      <Marquee
        speed={45}
        gradient
        gradientColor="#0A0A0A"
        gradientWidth={80}
        pauseOnHover
        direction="left"
      >
        {TESTIMONIALS.map((tst, i) => (
          <article
            key={i}
            data-testid={`testimonial-card-${i}`}
            className="mx-3 w-[320px] shrink-0 border border-white/10 bg-white/[0.04] p-5 backdrop-blur-sm sm:w-[380px]"
          >
            <div className="mb-2 flex">
              {Array.from({ length: tst.rating }).map((_, k) => (
                <Star key={k} className="h-4 w-4 fill-brand-orange text-brand-orange" />
              ))}
            </div>
            <p className="text-sm leading-relaxed text-white/90">"{tst.text}"</p>
            <div className="mt-3 flex items-center justify-between gap-2">
              <div className="text-[10px] font-bold uppercase tracking-[0.22em] text-brand-orange">
                {tst.name}
              </div>
              <div className="flex items-center gap-1.5 text-[9px] font-bold uppercase tracking-[0.18em] text-white/40">
                {tst.date && <span>{tst.date}</span>}
                <span aria-hidden="true">·</span>
                <span>Google</span>
              </div>
            </div>
          </article>
        ))}
      </Marquee>
    </section>
  );
}
